export default __webpack_public_path__ + "static/media/express.4f6e3a7b.png";